import React from "react";
import { Dropdown, IDropdownOption } from "@fluentui/react";

export interface CustomerTypeFilterProps {
  selectedTypes: string[];
  onSelectionChange: (selectedTypes: string[]) => void;
  disabled?: boolean;
}

const customerTypeOptions: IDropdownOption[] = [
  { key: "Carrier", text: "Carrier" },
  { key: "Shipper", text: "Shipper" },
  { key: "System", text: "System" },
];

const CustomerTypeFilter: React.FC<CustomerTypeFilterProps> = ({
  selectedTypes,
  onSelectionChange,
  disabled = false,
}) => {
  const handleSelectionChange = (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption,
    index?: number
  ) => {
    if (option) {
      const selectedKey = option.key as string;
      
      if (option.selected) {
        // Add to selection
        onSelectionChange([...selectedTypes, selectedKey]);
      } else {
        // Remove from selection
        onSelectionChange(selectedTypes.filter(type => type !== selectedKey));
      }
    }
  };

  // Set selected state for options
  const optionsWithSelection = customerTypeOptions.map(option => ({
    ...option,
    selected: selectedTypes.includes(option.key as string),
  }));

  return (
    <Dropdown
      placeholder="Filter by Customer Type"
      multiSelect
      options={optionsWithSelection}
      onChange={handleSelectionChange}
      disabled={disabled}
      styles={{
        dropdown: { width: 200 },
      }}
    />
  );
};

export default CustomerTypeFilter;
